
import React from 'react';
import { useActiveDirectoryState } from './useActiveDirectoryState';
import ActiveDirectoryCard from './ActiveDirectoryCard';
import AdvancedSettings from './AdvancedSettings';

interface ActiveDirectoryProps {
  editing: boolean;
}

const ActiveDirectory: React.FC<ActiveDirectoryProps> = ({ editing }) => {
  const {
    adConfig,
    autoSync,
    setAutoSync,
    handleConfigChange,
    handleConnect,
    handleDisconnect,
    handleSyncNow
  } = useActiveDirectoryState();

  return (
    <div className="space-y-6">
      <ActiveDirectoryCard 
        adConfig={adConfig}
        autoSync={autoSync}
        setAutoSync={setAutoSync}
        handleConfigChange={handleConfigChange}
        handleConnect={handleConnect}
        handleDisconnect={handleDisconnect}
        handleSyncNow={handleSyncNow}
        editing={editing}
      />
      <AdvancedSettings adConfig={adConfig} editing={editing} />
    </div>
  );
};

export default ActiveDirectory;
